import React from "react";
import {Box, Dialog, Divider, IconButton, Typography} from "@mui/material";
import ShareActions from "./ShareActions";
import {Close} from "@mui/icons-material";

const ShareDesktop = ({isOpen, handleClose, content}) =>{
    return <Dialog data-testId={"widget-share-desktop"} open={isOpen} onClose={handleClose} sx={{zIndex: 999999}}>
        <Box display={'flex'} px={1} width={'100%'} justifyContent={'space-between'} alignItems={'center'}>
            <Box pl={1}><Typography fontWeight={'500'}>Share</Typography></Box>
            <IconButton onClick={handleClose} disableRipple>
                <Close />
            </IconButton>
        </Box>
        <Divider />
            <Box p={2}>

                <ShareActions content={content}/>
            </Box>

    </Dialog>
}
export default ShareDesktop